import $ from 'jquery';

$(() => {
	const $link = $('.SmoothScroll');

	if (!$link.length) {
		return;
	}

	$(document)
		.off('click.SmoothScroll')
		.on('click.SmoothScroll', '.SmoothScroll', event => {
			event.preventDefault();
			const $target = $(event.currentTarget);
			const hash = $target.attr('href');
			console.log(hash);
			const element = $(hash);
			if (element.length) {
				const scrollPosition = element.offset().top;
				$('html, body').animate({ scrollTop: scrollPosition }, 500, 'swing');
			}
		});
});



// WEBPACK FOOTER //
// ./assets/scripts/smooth-scroll.js